import * as React from 'react';
import TextInput from './TextInput';

interface Props {
  id: string;
  value: number;
  label: string;
  icon?: string;

  // Adding a property for adding external css class. 
  textInputInputClassName?: string;
  textInputLabelClassName?: string;
  textInputIconClassName?: string;
  textInputDivClassName?: string;

  dataValidMessage?: string;
  dataInvalidMessage?: string;
  wrapperProps?: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >;
  iconProps?: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLElement>,
    HTMLElement
  >;
  inputProps?: React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >;
  labelProps?: React.DetailedHTMLProps<
    React.LabelHTMLAttributes<HTMLLabelElement>,
    HTMLLabelElement
  >;
  validator?(value: string): boolean;
  onChange(value: number): void;
  onChangeImmediate?(value: string): void;

}

interface State {
  intermediateValue?: string;
}

// let validMoneyRegExp = /^[0-9]+(\.[0-9]{1,2})?$/;
// added by rohini
let validMoneyRegExp = /^(?=.*\d)(?:\d+\.?\d*|\.\d+)$/;
class MoneyInput extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  handleBlur = (value: string) => {
    var valueLocal = value;
    if (value === '') {
      valueLocal = '0';
    }
    if (validMoneyRegExp.test(valueLocal)) {
      let numberValueSmallestDenomination = Math.round(parseFloat(valueLocal) * 100);

      this.props.onChange(numberValueSmallestDenomination);
    }

    this.setState({ ...this.state, intermediateValue: undefined });
  };

  numberToMoneyString(value: number): string {
    let asString = `${value}`;

    while (asString.length < 3) {
      asString = '0' + asString;
    }
    if (asString.substring (asString.length - 2) === '00') {
      return (
        asString.substring(0, asString.length - 2) 
      );
  
    } else if (asString.substring (asString.length - 1) === '0') {
      return (
        asString.substring(0, asString.length - 2) +
        '.' +
        asString.substring(asString.length - 2, asString.length - 1)
      );
  
    } else {
      return (
        asString.substring(0, asString.length - 2) +
        '.' +
        asString.substring(asString.length - 2)
      );
  
    }
  }

  render() {
    return (
      <TextInput
        {...this.props}
        onBlur={this.handleBlur}
        onChange={e => {
          this.setState({ ...this.state, intermediateValue: e });
        }}
        value={
          this.state.intermediateValue !== undefined
            ? this.state.intermediateValue
            : this.props.value === 0 ? '' : this.numberToMoneyString(this.props.value)
        }
       // validator={v => parseFloat(v) > 0}
       // Added by rohini
        validator={v => validMoneyRegExp.test(v)}
        forceHighlightErrors={true}
        dataInvalidMessage="Enter a donation."
        inputClassName={this.props.textInputInputClassName}
        labelClassName={this.props.textInputLabelClassName}
        iconClassName={this.props.textInputIconClassName}
        divClassName={this.props.textInputDivClassName}
        placeholder={this.props.value === 0  ? '0.00' : ''}
        isNumberOnly={true}
        
        onChangeImmediate={value => { if (this.props.onChangeImmediate) {  this.props.onChangeImmediate(value); } this.handleBlur(value); }}
      />
    );
  }
}

export default MoneyInput;



// WEBPACK FOOTER //
// ./src/Components/MoneyInput.tsx